import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { getIsMobile } from '@utils/utils';

import { IModalWrapperProps as IProps } from '../types';
import styles from '../PhoneConfirmModal.module.scss';
import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store/types';
import { Instance } from '@app/const/consts';

const PhoneConfirmWrapper: FC<IProps> = ({ children }) => {
  const { t } = useTranslation(['envelope']);
  const instanceRU = useAppSelector((state: RootState) => state.utils.instance) === Instance.RU;

  return (
    <Fragment>
      <header
        className={cn('p-4 modal-header', getIsMobile() && 'text-center')}
      >
        <h4 className='mb-0'>{t('envelope:phone.title')}</h4>
      </header>
      <div className={`p-4 ${instanceRU ? 'pb-8' : 'pb-5'} font-xs modal-body`}>
        {children}
        {instanceRU && (
          <div className={cn(styles.rules, 'text-muted')}>
            {t('common:rules1')}
            {getIsMobile() && <br/>}
            <a
              href='/assets/docs/Правила_платформы_greenDocs.pdf'
              className={cn(styles.rules__link, 'text-muted')}
              target='_blank'
              rel="noopener noreferrer"
            >
              {t('common:rules2')}
            </a>
            .
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default PhoneConfirmWrapper;
